module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_customer":"Add Customer","add_crop_inventory":"Add Crop Inventory"},"sw":{"add_customer":"Ongeza Mteja","add_crop_inventory":"Ongeza Mali ya Mazao"}}')
  delete Component.options._Ctor
}
